/**
 * Recommendations request
 * Fetches recommendations from the API
 * Returns a rail with the recommendations
 */
import ApiRequestManagerInstance from '../ApiRequestManager';
import Rail from '@shared/classes/rail';
import TranslationManager from '@shared/assets/locale/translationsManager';
import User from '@shared/classes/user';
import { IRecommendationsRequest } from '@shared/types/interfaces/rail';
import { RailDisplayMode, RailType } from '@shared/types/enums/rail';
import { store } from '@shared/store/store';

/**
 * Minimum recommendations count
 * If the recommendations count is less than this number, the request will return null
 */
const MINIMUM_RECOMMENDATIONS_COUNT = 10;

/**
 * Recommendations request
 * Fetches recommendations from the API
 * Returns a rail with the recommendations
 */
export default function recommendationsRequest() {
  return new Promise<Rail | null>(async (resolve, reject) => {
    try {
      const user = store.getState().user;
      const plan = User.getPlan(user.planId);
      if (!plan?.recommendationsEnabled) {
        resolve(null);
        return;
      }
      const response: IRecommendationsRequest =
        (await ApiRequestManagerInstance.get({
          endpoint: {
            url: 'apiUrl',
            version: 'v1',
            section: 'media',
            subsection: 'recommendations',
          },
        })) as unknown as IRecommendationsRequest;

      // Display rail only if there are enough recommendations
      const shows = response.data.medias;
      if (!shows.length || shows.length < MINIMUM_RECOMMENDATIONS_COUNT) {
        resolve(null);
        return;
      }

      // Build base rail
      const baseRail = {
        section: {
          title: TranslationManager.get(
            'COMPONENTS.RAILS.TITLE.RECOMMENDATIONS'
          ),
          presentationType: RailDisplayMode.PHOTO,
          name: 'recommendationsRail',
        },
        shows: { data: shows },
      };

      // Build recommendations rail
      const recommendationsRail = new Rail(
        baseRail,
        null,
        RailType.RECOMMENDATIONS
      );
      resolve(recommendationsRail);
    } catch (error) {
      reject(error);
    }
  });
}
